<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-none element-with-heading" id="uncategorized">
<div class="heading heading-with-title heading-without-image" id="uncategorized-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also by Patricia Dixon</h1>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center">Rosie &amp; Ruby</p>
<p class="alignment-block-content alignment-block-content-center">Anna</p>
<p class="alignment-block-content alignment-block-content-center">Tilly</p>
<p class="alignment-block-content alignment-block-content-center">Grace</p>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center">♥</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center">Over My Shoulder</p>
<p class="alignment-block-content alignment-block-content-center">They Don’t Know</p>
<p class="alignment-block-content alignment-block-content-center">Death’s Dark Veil</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsobypatriciadixon.vue?88548c34